import React, { Fragment, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import 'react-toastify/dist/ReactToastify.css';
import { Link, useNavigate } from "react-router-dom";
import Spinner from "../FieldComponets/Spinner";
import { ErrorMessage } from '@hookform/error-message';
import { useDispatch, useSelector } from 'react-redux';
import ToastDefault from "../FieldComponets/Toast";
import PageLayout from "../Layouts/PageLayout";
// import { CustomerGetAction, CustomerStatusAction } from '../../Redux/Action/CustomerAction';
import { CategoryAddAction, CategoryGetAction } from "../../Redux/Action/Category";
import { toast } from "react-toastify";
import { imageExtentionSupport } from "../../utils/Helper";
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { VALIDATION_MESSAGE } from "../../Constants/Constants";
import { FaqCrateaAction } from "../../Redux/Action/FaqAction";
import { FormattedMessage, useIntl } from "react-intl";




interface FormInputs {
  answer: string,
  question: string,
  user_type: string,

}
function FaqManagementAdd() {
  const dispatch = useDispatch<any>();
  const navigate = useNavigate()
  const intl = useIntl();
  const log_in = useSelector((state: any) => state.AdminLogInState)
  const faqstatus  = useSelector((state:any)=>state.FaqCreatestate)
  const [loading , setLoading] = useState(false)

  const formSchema: any = Yup.object().shape({
    question: Yup.string()
      .required(intl.formatMessage({ id: "please_enter_question" }))
      .trim()
      .min(2, intl.formatMessage({ id: "question_min_length" }))
      .max(255, intl.formatMessage({ id: "question_max_length" })),

    answer: Yup.string()
      .required(intl.formatMessage({ id: "please_enter_answer" }))
      .trim()
      .min(2, intl.formatMessage({ id: "answer_min_length" }))
      .max(255, intl.formatMessage({ id: "question_max_length" })),

    user_type: Yup.string()
      .required(intl.formatMessage({ id: "please_enter_user_type" }))
      .trim()


  });
  const { register, formState: { errors }, handleSubmit, watch, setValue } = useForm<FormInputs>({
    resolver: yupResolver(formSchema),
  });
  const onSubmit = (data: FormInputs) => {
    setLoading(true)
    dispatch(FaqCrateaAction(data))
  };
  useEffect(()=>{
  if(faqstatus.status){
    setTimeout(() => {
      navigate("/faq-list")
    }, 1000);
  }
  },[faqstatus])

  useEffect(() => {
        return () => {
            dispatch(FaqCrateaAction('RESET'));
        }
  }, [])
  return (
    <Fragment>
      {log_in?.loading || loading ? <Spinner /> : ""}
      <PageLayout
        title={intl.formatMessage({ id: "faq_add" })}
        breadcrumbs={{
          secLast: { 'link': '/faq-list', 'name': intl.formatMessage({ id: "faq_breadcrumb" }) },
        }}
        buttons={[
          { url: '/class-add', className: 'btn btn-primary', text: '+ Add Sponsors', show: false }, // This button will be shown
        ]}
      >


        <div className="mt-4">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row gy-4 mb-4 align-items-end">
              <div className="col-md-6">
                <label htmlFor="username" className="form-label"><FormattedMessage id="question" /></label>
                <input type="text" className="form-control mb-0" id="question" placeholder={intl.formatMessage({ id: "enter_question" })} {...register("question", {
                  required: intl.formatMessage({ id: "please_enter_question" }),

                })}
                  onInput={(e: any) => {
                    // e.target.value = e.target.value.replace(/\s/g, '');
                  }}
                />
                <ErrorMessage
                  errors={errors}
                  name="question"
                  render={({ message }) => <p className="mt-1" style={{ color: 'red' }}>{message}</p>}
                />
              </div>
              <div className="col-md-6">
                <label htmlFor="username" className="form-label"><FormattedMessage id="answer" /></label>
                <input type="text" className="form-control mb-0" id="answer" placeholder={intl.formatMessage({ id: "enter_answer" })} {...register("answer", {
                  required: intl.formatMessage({ id: "please_enter_answer" }),

                })}
                  onInput={(e: any) => {
                    // e.target.value = e.target.value.replace(/\s/g, '');
                  }}
                />
                <ErrorMessage
                  errors={errors}
                  name="answer"
                  render={({ message }) => <p className="mt-1" style={{ color: 'red' }}>{message}</p>}
                />
              </div>
              <div className="col-md-6">
                <label htmlFor="user_type" className="form-label"><FormattedMessage id="user_type" /></label>
                <select
                  id="user_type"
                  className="form-control profile-approve-dropdown mb-0"
                  {...register("user_type", {
                    required: intl.formatMessage({ id: "please_select_user_type" })
                  })}
                >
                  <option value="">{intl.formatMessage({ id: "select_user_type" })}</option>
                  <option value="Salon">{intl.formatMessage({ id: "salon" })}</option>
                  <option value="Customer">{intl.formatMessage({ id: "customer" })}</option>
                </select>
                <ErrorMessage
                  errors={errors}
                  name="user_type"
                  render={({ message }) => <p className="mt-1" style={{ color: 'red' }}>{message}</p>}
                />
              </div>
              <div className="col-md-2 col-sm-6 col-12">
                <button type="submit" className="btn btn-primary waves-effect waves-light w-100"><FormattedMessage id="save_caps" /></button>
              </div>
            </div>

          </form>
        </div>
        <ToastDefault />
      </PageLayout>
    </Fragment>
  );
}

export default FaqManagementAdd
